
//手机列表
const phoneList = [{
        width: "30",
        align: 'left',
        selection: true,
        reserve: true,
    }, {
        prop: "Id",
        label: "ID",
        width: "140",
        align: 'left',
        headerAlign: 'left',
        selection: false,
        index: false,
        expand: false,
        sortable: true,
    }
]

//上传文件列表
const filecloumns = [{
    prop: "filename",
    label: "文件名",
    width: "150",
    align: 'left',
    headerAlign: 'left',
    selection: false,
    index: false,
    expand: false,
}, {
    prop: "filesize",
    label: "文件大小",
    width: "100",
    align: 'left',
    headerAlign: 'left',
    selection: false,
    index: false,
    expand: false,
}, {
    prop: "filetype",
    label: "文件类型",
    width: "100",
    align: 'left',
    headerAlign: 'left',
    selection: false,
    index: false,
    expand: false,
}, {
    prop: "fileprogress",
    label: "进度",
    width: "100",
    align: 'left',
    headerAlign: 'left',
    selection: false,
    index: false,
    expand: false,
}, {
    prop: "filestate",
    label: "状态",
    width: "100",
    align: 'left',
    headerAlign: 'left',
    selection: false,
    index: false,
    expand: false,
}]

const renewList = [{
    prop: "product_type",
    label: "产品类型",
    width: "100",
    align: 'left',
    headerAlign: 'left',
    selection: false,
    index: false,
    expand: false,
    formatter: (row, column, cellValue, index) => {
      
            return '手机'
     
    }
}, {
    prop: "name",
    label: "资源名称",
    width: "120",
    align: 'left',
    headerAlign: 'left',
    selection: false,
    index: false,
    expand: false,
}]
export {
    phoneList,
    filecloumns,
    renewList,
   
}